import requests from '@/utils/request'

/**
 * 创建记录
 * new_post,code,destination,datetime,position,note,status
 * @param {*} data
 * @returns
 */
export const reqCreateRecord = (data) => requests({ url: '/logisticsTrack/createRecord', method: 'post', data })

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const reqDeleteRecord = (id) => requests({ url: '/logisticsTrack/deleteRecord', method: 'post', data: { id } })

/**
 * 更新记录
 * @param {*} data
 * @returns
 */
export const reqUpdateRecord = (data) => requests({ url: '/logisticsTrack/updateRecord', method: 'post', data })

/**
 *  获取记录列表
 * @param {*} data
 * @returns
 */
export const reqRecordList = (data) => requests({ url: '/logisticsTrack/getRecordList', method: 'post', data })

/**
 * 
 * 创建留言
 * 
 * 
 */
export const reqCreateMessage = (data) => requests({url:'/message/createRecord', method: 'post', data})

/**
 * 
 * 获取留言列表
 * 
 */
export const reqMessageList = (data) => requests({url:'/message/getRecordList', method: 'post', data})

/**
 * 
 * 获取留言详情
 * 
 */
 export const reqMessageDetail = (data) => requests({url:'/message/getRecord', method: 'post', data})

/**
 * 
 * 获取验证码
 * 
 */
export const reqAuthCode = () => requests({url:'/captcha/createCaptcha', method: 'post'})

/**
 * 登录后台
 * 
 */
export const reqLogin = (data) => requests({url:'/account/login', method: 'post',data})


/**
 * 
 * 修改密码
 * 
 */
export const reqChangePassword = (data) => requests({url:'/account/updatePwd', method: 'post',data})